<mat-chip-list rounded>
  <ng-container *ngFor="let tag of tags; trackBy: trackTag">
    <mat-chip
      [removable]="false"
      size="sm"
      [ngStyle]="{ backgroundColor: tag.isSystem ? '#141217' : '#2C2A30' }"
      class="tagsChip"
    >
      <div class="tagsChipLabel">
        <span>{{ tag.name }}</span>
        <mat-icon
          matChipRemove
          [attr.aria-label]="'tags.removeTag' | t"
          (click)="onTagRemoved(tag)"
          class="cancelIcon"
          *ngIf="canChange && canUserDeleteTag && !tag.isSystem"
          >cancel</mat-icon
        >
      </div>
    </mat-chip>
  </ng-container>

  <button
    mat-icon-button
    [attr.aria-label]="'tags.addTag' | t"
    [matTooltip]="'tags.addTag' | t"
    matTooltipPosition="below"
    class="add-button"
    [matMenuTriggerFor]="menu"
    *ngIf="canChange && (canUserAddTag || canUserChangeTag)"
  >
    <sn-icon size="sm" fontSet="fal" fontIcon="fa-plus" class="addIcon"></sn-icon>
  </button>
</mat-chip-list>

<mat-menu #menu="matMenu" xPosition="after">
  <ng-template matMenuContent>
    <sn-tag-selection
      [contentType]="contentType"
      [selectedTags]="tags"
      (click)="$event.stopPropagation()"
      (tagsSelectionChanged)="onTagsSelectionChanged($event)"
    >
    </sn-tag-selection>
  </ng-template>
</mat-menu>
